// setState güncelleyicisi: veri değişmediyse aynı referansı korur (anlık yenilemede gereksiz render/kasma olmaz)
export const sameOrNew = (next) => (prev) => (JSON.stringify(prev) === JSON.stringify(next) ? prev : next);

export const TRY = (n) =>
  new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
  }).format(Number(n || 0));

// Belge dosya adı: cari adının ilk iki kelimesi + belge no (ör. "ÇAKIR ELEKTRİK GIB2026000000123.pdf")
export const cariShort = (t) => String(t || "").trim().split(/\s+/).slice(0, 2).join(" ");
export const docFileName = (title, no, ext = "pdf") => {
  const base = [cariShort(title), String(no || "").trim()].filter(Boolean).join(" ").replace(/[\\/:*?"<>|#]+/g, "").replace(/\s+/g, " ").trim() || "Belge";
  return ext ? `${base}.${ext}` : base;
};

export const NUM = (n) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 }).format(Number(n || 0));

// Birim yazımı tekleştirme (görüntü/yeni kayıt): AD → ADET, MT → METRE; diğerleri büyük harf
const UNIT_FIX = { AD: "ADET", MT: "METRE" };
export const unitLabel = (u, def = "") => { const s = String(u ?? "").trim().toLocaleUpperCase("tr-TR") || def; return UNIT_FIX[s.replace(/\.$/, "")] || s; };

export const fmtDate = (d) => {
  if (!d) return "-";
  const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  try {
    return new Date(d).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return d;
  }
};

// Tarih + saat, Europe/Istanbul saat diliminde (created_at UTC olarak saklanır → +3 düzeltir).
export const fmtDateTime = (d) => {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleString("tr-TR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit", timeZone: "Europe/Istanbul",
    });
  } catch {
    return fmtDate(d);
  }
};

export const todayISO = () => new Date().toLocaleDateString("sv-SE");   // yerel (TR) tarih — gece 00-03 arası dünü vermez

// Ürün adını her zaman marka ön ekiyle gösterir (ör. "VİKO Karre Beyaz Topraklı Priz").
// Ad zaten marka ile başlıyorsa tekrarlamaz.
export const pname = (p) => {
  if (!p) return "";
  const name = (p.name || "").toString().trim();
  const brand = (p.brand || "").toString().trim();
  if (!brand) return name;
  const n = name.toLocaleLowerCase("tr-TR");
  const b = brand.toLocaleLowerCase("tr-TR");
  if (!name) return brand;
  if (n === b || n.startsWith(b)) return name;
  return `${brand} ${name}`;
};
